import PageForm from 'components/pageForm/PageForm';
import LineTabs from 'components/tabs/LineTabs';

/**
 * The page of a record (a company, a group, a contact), as on the prototype:
 * on the left its identity, its actions and its information, which stay in
 * place on the whole height; on the right its numbers, its tabs and their
 * content, which scroll. Below 1024 px the two columns stack.
 */
const RecordLayout = ({ title, side, children }) => (
  <PageForm title={title}>
    {/* items-start: each column is as high as its content, not as the screen,
        or what sticks at the top of one would leave with it. */}
    <main className="flex min-h-0 flex-1 flex-col gap-5 overflow-y-auto px-4 py-5 ls:flex-row ls:items-start lg:px-8">
      <aside className="flex w-full shrink-0 flex-col gap-4 ls:sticky ls:top-0 ls:h-full ls:w-[350px] ls:overflow-y-auto">
        {side}
      </aside>
      <div className="flex min-w-0 flex-1 flex-col gap-5">{children}</div>
    </main>
  </PageForm>
);

// The tabs of a record, stuck at the top of the right column: the numbers
// leave with the page, the tabs stay.
export const RecordTabs = ({ tabs, activeTab, onChange }) => (
  <div className="sticky -top-5 z-20 -mt-5 bg-white pt-5">
    <LineTabs tabs={tabs} activeTab={activeTab} onChange={onChange} />
  </div>
);

// A card of a record: a title, what acts on it, and its content.
export const RecordSection = ({ title, action, className = '', children }) => (
  <section className={`rounded-xl border border-gray-100 p-4 ${className}`}>
    {(title || action) && (
      <div className="mb-2 flex items-center justify-between gap-3">
        {title && <p className="text-sm font-medium text-gray-900">{title}</p>}
        {action}
      </div>
    )}
    {children}
  </section>
);

export default RecordLayout;
